// Route table for the demo adapter. Each module exports `routes`: a list of
// [METHOD, pattern, handler] where pattern is a path (no leading slash, as
// sent relative to /api/) with optional `:param` segments, or a RegExp.
// First match wins, so put specific patterns before generic ones.

const modules = import.meta.glob('./routes/*.js', { eager: true });

function compile(pattern) {
  if (pattern instanceof RegExp) return pattern;
  const trimmed = pattern.replace(/^\/+|\/+$/g, '');
  const src = trimmed
    .split('/')
    .map((seg) => (seg.startsWith(':') ? `(?<${seg.slice(1)}>[^/]+)` : seg.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')))
    .join('/');
  return new RegExp(`^${src}/?$`);
}

const table = Object.keys(modules)
  .sort()
  .flatMap((key) => (modules[key].routes || []).map(([method, pattern, handler, opts = {}]) => ({
    method,
    regex: compile(pattern),
    handler,
    silent: Boolean(opts.silent),
  })));

export function matchDemoRoute(method, path) {
  for (const route of table) {
    if (route.method !== '*' && route.method !== method) continue;
    const m = route.regex.exec(path);
    if (m) return { handler: route.handler, match: m.groups || {}, silent: route.silent };
  }
  return null;
}
